<template>
  <v-dialog scrollable max-width="300px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn color="primary" text :disabled="disabled" v-on="on" @click="init"
          >AGREGAR REGLA</v-btn
        >
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>NUEVA REGLA</h4>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">
          <v-autocomplete
            v-model="regla.origen"
            :items="origenes"
            dense
            filled
            label="Origen"
            :rules="[rules.required]"
          ></v-autocomplete>

          <AsignacionAutocomplete
            ref="asig"
            :filtro="[1,2,3,5,6,7,10,14,15,18,20,22,23,26,30,33,37,41,42,43,44,45,46,50 ]"
            :id="regla.asignacion.id"
            @asignacionId="setAsignacionId"
          />

          <v-text-field
            label="Descripcion"
            v-model="regla.descripcion"
            :rules="[rules.required]"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="close">Volver</v-btn>
        <v-btn color="info" @click="confirmar" :disabled="!validForm">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import AsignacionAutocomplete from '@/components/shared/AsignacionAutocomplete.vue'

export default {
  components: {
    AsignacionAutocomplete
  },
  props: {
    disabled: { type: Boolean, default: false },
    bolsa: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      origenes: ["BMAT", "PLAD", "PLDD", "PLMF", "PLDP","MFSO","RBT","CP01",'EXT','INT'],
      regla: {
        origen: "BMAT",
        descripcion: "",
        asignacion: { id: null },
        bolsa: { id: null },
      },
      rules: {
        required: (value) => !!value || "Requerido.",
        numero: (value) => {
          if (value) {
            return (
              (value > 0 && value <= 1000) || "Ingrese valor entre 1 y 1000"
            );
          }
          return true;
        },
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
    };
  },
  mounted() {
    this.nuevoMonto = this.monto;
  },
  methods: {
    init() {
      this.regla.descripcion = '';
    },
    close() {
      this.$refs.form.resetValidation();
      this.showDialog = false;
    },
    confirmar() {
      this.regla.bolsa.id = this.bolsa.id;
      axios
        .put("/regla/", this.regla)
        .then((response) => {
          console.log(response);
          this.$emit("actualizado");
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.nuevaCedula = this.cedula;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    setAsignacionId(id) {
      this.regla.asignacion.id = id;
    }
  },
};
</script>